import { Abstrap } from '../..';

const { propTypes } = Abstrap;

const defaultProps = { ...Abstrap.defaultProps, componentClass: 'div' };

class TabMenuTop extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-tab-menu__top',
            className,
        ];
    }

}

TabMenuTop.propTypes = propTypes;

TabMenuTop.defaultProps = defaultProps;

export default TabMenuTop;
